import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  HeaderGridRow,
  GridItem,
  OrderServiceInfo,
} from "../../GeneralPlanningList.styled";

const Header = (props) => {
  const { t, page } = props;
  const pageTranslation = {
    global: "SUPPLIERS_PLANNING",
    site: "SITE_PLANNING",
    daily: "SUPPLIERS_PLANNING",
  };

  return (
    <OrderServiceInfo>
      {/* <HeaderGridRow
        column={
          page === "site"
            ? "6% 5% 20% 20% 20% 5% 5% 7% 6% 6%"
            : page === "daily"
            ? "14% 5% 20% 20% 20% 5% 5% 5% 5%"
            : "6% 16% 21% 21% 21% 5% 5% 5%"
        } */}
      <HeaderGridRow
        column={
          page === "site"
            ? "9% 22% 20% 20% 5% 5% 7% 6% 6%"
            : page === "daily"
            ? "15% 23% 20% 20% 5% 5% 5% 7%"
            : "6% 15% 20% 19% 19% 5% 5% 5% 6%"
        }
        marginBottom="0px"
        gridGap="0rem"
        marginTop="0px"
      >
        {(page === "global" || page === "site") && (
          <GridItem
            padding="8px"
            textAlign="left"
            fontWeight="700"
            radius="5px 0px 0px 0px"
            borderRight="1px solid #fff"
          >
            {t(`${pageTranslation[page]}_DATE`)}
          </GridItem>
        )}
        {(page === "global" || page === "daily") && (
          <GridItem
            padding="8px"
            textAlign="left"
            fontWeight="700"
            borderRight="1px solid #fff"
          >
            {t(`${pageTranslation[page]}_SITE_COMPANY`)}
          </GridItem>
        )}
        {/* {page === "site" && (
          <GridItem
            padding="8px"
            textAlign="left"
            fontWeight="700"
            borderRight="1px solid #fff"
          >
            {t("LINE_GROUP_ID")}
          </GridItem>
        )} */}
        <GridItem
          padding="8px"
          textAlign="left"
          fontWeight="700"
          borderRight="1px solid #fff"
        >
          {t(`${pageTranslation[page]}_SERVICE`)}
        </GridItem>

        <GridItem
          padding="8px"
          textAlign="left"
          fontWeight="700"
          borderRight="1px solid #fff"
        >
          {t(`${pageTranslation[page]}_HAULAGE`)}
        </GridItem>
        <GridItem
          padding="8px"
          textAlign="left"
          fontWeight="700"
          borderRight="1px solid #fff"
        >
          {t(`${pageTranslation[page]}_SOLUTION`)}
        </GridItem>

        <GridItem
          textAlign="left"
          fontWeight="700"
          padding="8px"
          borderRight="1px solid #fff"
        >
          {t(`${pageTranslation[page]}_PLANNED`)}
        </GridItem>
        {page === "site" && (
          <GridItem
            padding="8px"
            textAlign="left"
            fontWeight="700"
            borderRight="1px solid #fff"
          >
            {t("SITE_PLANNING_REALISED")}
          </GridItem>
        )}
        <GridItem padding="8px" fontWeight="700" borderRight="1px solid #fff">
          {t(`${pageTranslation[page]}_TURNOVER`)}
        </GridItem>
        <GridItem
          padding="8px"
          fontWeight="700"
          radius="0px"
          borderTopRightRadius={page === "site" ? "0px" : "5px"}
          borderRight={
            page === "site" || page === "daily" || page === "global"
              ? "1px solid #fff"
              : "0px solid #767676"
          }
        >
          {t(`${pageTranslation[page]}_MARGIN`)}
        </GridItem>
        <GridItem
          padding="8px"
          textAlign="left"
          fontWeight="700"
          radius="0px 5px 0px 0px"
          borderRight="0px solid #767676"
        >
          &nbsp;
        </GridItem>
      </HeaderGridRow>
    </OrderServiceInfo>
  );
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Header);
